import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ITaxesSetupContainerProps } from "./TaxesSetupContainer";

const TaxContainerSetupComponent = lazyLoadWithRetry(() => import("./TaxesSetupContainer"));

type TaxSetupContainerRouteProps = Omit<
    ITaxesSetupContainerProps,
    "handler" | "history" | "location" | "match"
>;

export const TaxSetupContainerRoute: React.FunctionComponent<TaxSetupContainerRouteProps> = (
    props,
) => (
    <RouteRelative
        path={routes.tax.settings}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <TaxContainerSetupComponent {...props} {...routeProps} />
                </BTSuspense>
            );
        }}
    />
);
